import { render, staticRenderFns } from "./SideNotification.vue?vue&type=template&id=cd8e4e70&scoped=true&"
import script from "./SideNotification.vue?vue&type=script&lang=ts&"
export * from "./SideNotification.vue?vue&type=script&lang=ts&"
import style0 from "./SideNotification.vue?vue&type=style&index=0&id=cd8e4e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8e4e70",
  null
  
)

export default component.exports